import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'if_yes_do_wrkrs_confirm_the_accuracy_of_payouts_and_repayments'

export const dataPointDefinition = {
  retracedId: 'if_yes_do_wrkrs_confirm_the_accuracy_of_payouts_and_repayments',
  name: 'If yes, do workers confirm the accuracy of payouts and re-payments in writing?',
  description:
    'The intent of this question is to understand if there is some kind of written evidence from workers that confirms the initial advance or loan amount given and (if applicable) written evidence that confirms repayment installment amounts from the worker back to the facility, etc. \r\r\n\r\r\nFor example, workers might confirm the initial amount given and as well as each amount that is paid back via signature.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-17--4',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 8810,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
